import { cn } from '@/helpers/cn'

import type { ReactNode } from 'react'

type Size = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

interface Props {
  children: ReactNode
  className?: string
  size?: Size
  color?: string
  id?: string
}

export function Heading({ children, className, size = 'h3', color = 'text-body-text-header', id }: Props) {
  switch (size) {
    case 'h1':
      return (
        <h1 id={id} className={cn('font-bold font-sans text-[2.5rem] leading-12 tracking-normal', color, className)}>
          {children}
        </h1>
      )
    case 'h2':
      return (
        <h2 id={id} className={cn('font-bold font-sans text-[2rem] leading-10 tracking-normal', color, className)}>
          {children}
        </h2>
      )
    case 'h3':
      return (
        <h3 id={id} className={cn('font-bold font-sans text-2xl leading-8 tracking-normal', color, className)}>
          {children}
        </h3>
      )
    case 'h4':
      return (
        <h4 id={id} className={cn('font-bold font-sans text-[1.25rem] leading-6 tracking-normal', color, className)}>
          {children}
        </h4>
      )
    case 'h5':
      return (
        <h5 id={id} className={cn('font-bold font-sans text-[1rem] leading-5 tracking-normal', color, className)}>
          {children}
        </h5>
      )
  }
}
